import { render, staticRenderFns } from "./TotalMessage.vue?vue&type=template&id=12b54d1b"
import script from "./TotalMessage.vue?vue&type=script&lang=js"
export * from "./TotalMessage.vue?vue&type=script&lang=js"
import style0 from "./TotalMessage.vue?vue&type=style&index=0&id=12b54d1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports